import type { ListSettingsRows, ListSettingsTarget } from 'app/types/list-settings'
import { isFilterList } from 'lib/practiceLists'

/**
 * The Settings rows each list kind gets (spec 2026-10-14). A system list belongs to the
 * product, so it has no List section, and its boards draw fixed cards, so it has no Cards row.
 * Active Leads' stages are the lead statuses, which nobody edits.
 */
export function listSettingsRows(target: ListSettingsTarget): ListSettingsRows {
  if (target.source === `system`)
    return { listSection: false, editRule: false, stages: target.def.listKind !== `leads`, cards: false }
  return { listSection: true, editRule: isFilterList(target.list), stages: true, cards: true }
}
